import React from 'react';
import classNames from 'classnames';
import { ToastContainer, toast, cssTransition } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';
import '../../../global-css/toast.css';

const Fade = cssTransition({
  enter: 'fadeInDown',
  exit: 'fadeInUp',
  duration: 1000,
});

export const showToast = toast;

const getIcon = (type) => {
  switch (type) {
    case 'success':
      return 'fas fa-check-circle';
    case 'error':
      return 'fas fa-exclamation-circle';
    default:
      return '';
  }
};

export const ToastBody = ({ icon, title, subtitle }) => {
  const iconClass = getIcon(icon);
  return (
    <div className="toast-body">
      {icon && <i className={classNames('icon', iconClass)} />}
      <div className={classNames('content', subtitle ? 'rows' : 'row')}>
        <h3>{title}</h3>
        {subtitle && <p>{subtitle}</p>}
      </div>
    </div>
  );
};

const CloseButton = ({ closeToast }) => (
  <button type="button" className="close-button" onClick={closeToast}>
    <i className="fal fa-times" />
  </button>
);

export const Toast = () => (
  <ToastContainer
    className="cart-toast"
    autoClose={false}
    hideProgressBar
    newestOnTop={false}
    closeOnClick
    rtl={false}
    pauseOnFocusLoss={false}
    draggable={false}
    pauseOnHover={false}
    transition={Fade}
    closeButton={CloseButton}
  />
);

export const showErrorToast = (title, subtitle) => {
  showToast.error(<ToastBody icon="error" title={title} subtitle={subtitle} />);
};

export const showInfoToast = (title, subtitle) => {
  showToast.info(<ToastBody title={title} subtitle={subtitle} />);
};

export const dismissAll = () => toast.dismiss();
